<div class="container-fluid">
    <div class="dialog-header">
        <h2 mat-dialog-title>{{dialogTitle}}</h2>
        <button mat-icon-button class="close-button" mat-dialog-close name="shareDialogCloseBtn">
            <mat-icon class="close-icon">close</mat-icon>
        </button>
    </div>
    
    <mat-dialog-content class="share-dialog-content">
        <div class="row">
            <div class="col-md-6">
                <mat-form-field class="full-width">
                    <mat-label>From Date</mat-label>
                    <input matInput [matDatepicker]="fromDatePicker" 
                           [formControl]="fromDateControl" 
                           [min]="minDate"
                           placeholder="Select from date">
                    <mat-datepicker-toggle matSuffix [for]="fromDatePicker">
                        <mat-icon matDatepickerToggleIcon>
                            <img src="assets/images/icons/purple_icons/icon-calendar.png" alt="icon-calendar">
                        </mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #fromDatePicker></mat-datepicker>
                    <mat-error *ngIf="fromDateControl.hasError('required')">
                        From date is required
                    </mat-error>
                </mat-form-field>
            </div>
            
            <div class="col-md-6">
                <mat-form-field class="full-width">
                    <mat-label>To Date</mat-label>
                    <input matInput [matDatepicker]="toDatePicker" 
                           [formControl]="toDateControl" 
                              [min]="minToDate"
                              [max]="maxToDate"
                           placeholder="Select to date">
                    <mat-datepicker-toggle matSuffix [for]="toDatePicker">
                        <mat-icon matDatepickerToggleIcon>
                            <img src="assets/images/icons/purple_icons/icon-calendar.png" alt="icon-calendar">
                        </mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #toDatePicker></mat-datepicker>
                    <mat-error *ngIf="toDateControl.hasError('required')">
                        To date is required
                    </mat-error>
                    @if (toDateControl.hasError('dateRange') ||
                    toDateControl.hasError('matDatepickerMax')) {
                    <mat-error>
                        To date must be within 7 days of from date
                    </mat-error>
                    }
                    
                </mat-form-field>
            </div>
        </div>
        
        <div class="row">
            <div class="col-md-12">
                <mat-form-field class="full-width">
                    <mat-label>Hiring Manager Email</mat-label>
                    <mat-chip-grid #hmChipGrid [formControl]="hmChipControl">
                        @for (hm of selectedHiringManagers(); track hm.email + hm.empId; let i = $index) {
                        <mat-chip-row (removed)="removeHiringManager(i)">
                            {{ hm.empName }} ({{ hm.email }})
                            <button matChipRemove>
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </mat-chip-row>
                        }
                    </mat-chip-grid>
                    <input #hmInput
                           [formControl]="emailControl"
                           [matChipInputFor]="hmChipGrid"
                           [matAutocomplete]="auto"
                           (blur)="onHmBlur()"
                           placeholder="Type employee number or email">
                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onHiringManagerSelected($event)" [displayWith]="displayEmpFn">
                        @for (emp of filteredEmp(); track emp.mailId) {
                        <mat-option [value]="emp">
                            {{ emp.empName }} ({{ emp.mailId }})
                        </mat-option>
                        }
                    </mat-autocomplete>
                    <mat-hint>Add hiring managers one at a time by selecting a suggestion from the list.</mat-hint>
                    <mat-error *ngIf="hmChipControl.hasError('required')">
                        Hiring Manager Email is required
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        
        @if (showResumeCheckbox) {
        <div class="row">
            <div class="col-md-12">
                <mat-checkbox [formControl]="includeResumeControl">
                    Candidate Resume
                </mat-checkbox>
            </div>
        </div>
        }

    @if (showVerificationSnapshot()) {
    <div class="row">
      <div class="col-md-12">
        <mat-checkbox [formControl]="includeVerificationSnapshotControl">
          Verification Snapshot
        </mat-checkbox>
      </div>
    </div>
    }

    <div class="row">
      <div class="col-md-12" style="text-align: right">
        <button mat-flat-button class="primary-btn" (click)="onShare()" [disabled]="!isFormValid">Share</button>
      </div>
    </div>
  </mat-dialog-content>
</div>
